import {Injectable} from '@angular/core';
import { Router, RouterStateSnapshot } from '@angular/router';
import {SsrCookieService} from "ngx-cookie-service-ssr";

@Injectable()
export class AuthGuard  {

  constructor(private router: Router,
              private cookieService: SsrCookieService) { }

  canActivate(state: RouterStateSnapshot) {
    if (this.cookieService.get("auth-token")) {
      // logged in so return true
      return true;
    }

    // not logged in so redirect to login page with the return url and return false
    this.router.navigate(['connexion'], {queryParams: {returnUrl: state.url}});
    return false;
  }
}
